import type { Command, CommandContext } from "./Command";
import { withComponent } from "../../world/Entity";
import type { EntityId } from "../../world/Entity";
import type { ClothingSlot } from "../../world/components";

/** Equip a clothing item directly from the scene — removes it from the scene and puts it on the character. */
export class EquipFromSceneCommand implements Command {
  constructor(
    private readonly characterId: EntityId,
    private readonly entityId: EntityId,
    private readonly slot: ClothingSlot,
  ) {}

  execute(context: CommandContext): void {
    const entity = context.world.getEntity(this.entityId);
    if (!entity) throw new Error(`Cannot equip unknown entity "${this.entityId}"`);

    context.world.removeEntityFromScene(this.entityId);
    context.world.updateEntity(this.characterId, (e) =>
      withComponent(e, "character", (c) => ({
        ...c,
        clothing: { ...c.clothing, [this.slot]: entity.definitionId },
      })),
    );
    context.events.emit("character:dressed", { characterId: this.characterId, slot: this.slot, instanceId: this.entityId });
  }
}
